import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { OutrightBetState } from './OutrightBet.state';


interface PropsTypes {
    outrightBetState: OutrightBetState
}

export const MarketsFilter = observer('MarketsFilter', ({ outrightBetState }: PropsTypes) => {
    return (
        <div className='outright-tab-events__filter'>
            <nav className='filters outright__markets-filter'>
                <ul>
                    {outrightBetState.marketsFilter.map(market => {
                        const isActive = outrightBetState.activeMarketSlug === market.slug;

                        return (
                            <li key={market.slug} className={isActive ? 'active' : ''}>
                                <a href='#' onClick={(): void => outrightBetState.onFilterMarketSlug(market.slug)}>
                                    {market.name}
                                </a>
                            </li>
                        );
                    })}
                </ul>
            </nav>
        </div>
    );
});
